import { FieldType, TableColumnMetadata } from "./types";
import { Property } from "@ploy-lib/types";

export class PropertySchema {
	static metaData: Partial<
		Record<keyof Property, TableColumnMetadata<Property>>
	> = {
		refinance: {
			fieldType: FieldType.Checkbox,
			alwaysEditable: true
		},
		streetName: {
			fieldType: FieldType.Text,
			displayValue: (value: any, rowData: Property) => {
				return `${rowData.streetName} ${rowData.addressNumber || ""}${
					rowData.addressLetter || ""
				}`;
			}
		},
		// addressNumber: {
		// 	fieldType: FieldType.Text
		// },
		postalCode: {
			fieldType: FieldType.Text
		},
		cadastralNumber: {
			fieldType: FieldType.Text
		},
		municipalityNumber: {
			fieldType: FieldType.Text
		},
		cadastralUnitNumber: {
			fieldType: FieldType.Text
		},
		unitNumber: {
			fieldType: FieldType.Text
		},
		leaseholdUnitNumber: {
			fieldType: FieldType.Text
		},
		valueEnteredByCustomer: {
			fieldType: FieldType.Currency
		},
		estimatedValue: {
			fieldType: FieldType.Currency,
			alwaysEditable: true
		},
		utilizedValue: {
			fieldType: FieldType.Currency,
			alwaysEditable: true
		},
		utilizedSecurityValue: {
			fieldType: FieldType.Currency,
			alwaysEditable: true
		},
		ownedBy: {
			fieldType: FieldType.Multiselect
		},
		eAppraisalReference: {
			fieldType: FieldType.Text,
			alwaysEditable: true
		}
	};
}
